export default "__VITE_ASSET__BaQmL55W__"